import './App.scss';
import 'primeflex/primeflex.scss';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
//import 'primereact/resources/themes/nova-light/theme.css';
import 'styles/theme.scss';
import 'styles/media.scss';
import FormView from 'page/FormView';
import Footer from 'components/chrome/Footer';
import Landing from 'page/Landing';
import Limbo from 'page/Limbo';
import Logout from 'page/Logout';
import React from 'react';
/* import ReactGa from 'react-ga'; */
import RedirectView from 'page/RedirectView';
import ScrollToTop from 'components/chrome/ScrollToTop';
import Server from 'data/Server';
import Sidenav from 'components/chrome/Sidenav';
import Sitemap from './Sitemap';
import Topnav from 'components/chrome/Topnav';
import authProtect from 'auth/authProtect';
import { BrowserRouter } from 'react-router-dom';
import { GrowlElement } from 'components/chrome/Growl';
import { Route } from 'react-router';


const LOGIN_LANDING_PAGE = '/analyze';


const makePageRoute = item => {
  let component = item.component;
  if (!component) {
    if (item.children && item.children.length > 0) {
      return <Route
          key={item.label}
          exact path={item.path}
          render={_ => <RedirectView destination={item.children[0].path} />} />;
    }
    return null;
  }
  component = item.unauth ? component : authProtect(component);
  const c = {o: component};
  return <Route
      key={item.label}
      exact path={item.path || `/${item.label.toLowerCase()}`}
      render={_ => <c.o {...item.componentProps} />} />;
}


const makeChildPageRoutes = item => {
  return (
    <div key={item.label + '-children'}>
      {(item.children || []).map(makePageRoute)}
    </div>
  );
}


const gaRoute = (
  <Route path='/' render={({location}) => {
      return null; /* TODO remove this */
      /*
        if (location.pathname[1] === '_') return null;
        ReactGa.initialize('UA-4516355-9');
        ReactGa.pageview(location.pathname + location.search);
        console.log(location.pathname + location.search);
        return null;
      */
    }} />
);


class App extends React.Component {
  constructor() {
    super();
    this.server = new Server.Factory().create();
    this.server.listen(this.onServerDataChange.bind(this));
    this.sitemap = new Sitemap.Factory().create();
  }

  onServerDataChange(data) {
    this.setState({ server_data: data });
  }

  render() {
    const topnavItems =
        this.server.user_email() ? this.sitemap.getTopnavItems() : [];
    return (
      <div className='App'>
        <BrowserRouter>
          <ScrollToTop>
            {gaRoute}
            <GrowlElement />
            <Topnav links={topnavItems}>
              Platform Demo
            </Topnav>
            <div className='backdrop'>
              <Sidenav />
              <div className='App-content'>
                <Route exact path='/' component={Landing} />
                <Route path={Limbo.prefix()} component={Limbo} />
                <Route path='/form/:formPath' component={FormView} />
                <Route exact path='/login'
                    render={_ => <FormView formPath='/login' formNext={LOGIN_LANDING_PAGE} />} />
                <Route exact path='/goodbye' component={Logout} />
                {topnavItems.map(makePageRoute)}
                {topnavItems.map(makeChildPageRoutes)}
              </div> {/* App-content */}
            </div> {/* backdrop */}
            <Footer />
          </ScrollToTop>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
